import { useCurrentEditor } from '@tiptap/react';

import { useEditorSearchFocus } from '../hooks/useEditorSearchFocus';

interface EditorSearchFocusProps {
  editorId: string;
}

export function EditorSearchFocus({ editorId }: EditorSearchFocusProps) {
  const { editor } = useCurrentEditor();

  useEditorSearchFocus({ editor, editorId });

  return null;
}
